// Module-level draft for the anonymous newsletter capture form on the
// public profile. The band renders in two homes (mobile exit slot /
// desktop rail foot) with one instance visible per breakpoint, so the
// draft lives here and both instances subscribe — an email typed at
// mobile width must survive a rotation across the lg boundary. Local
// component state stays the render boundary: typing re-renders only the
// two memo'd forms, never the page.
//
// This is a session-scoped module cache holding user-typed PII, so it is
// cleared by invalidateSessionCaches() at auth boundaries (the
// cacheInvalidation contract: after an auth boundary, no module cache
// holds anything) and by the form on a successful subscribe.

const store = { value: '', listeners: new Set() };

export const getNewsletterDraft = () => store.value;

export const setNewsletterDraft = (value) => {
  store.value = value;
  store.listeners.forEach((listener) => listener(value));
};

export const subscribeNewsletterDraft = (listener) => {
  store.listeners.add(listener);
  return () => { store.listeners.delete(listener); };
};

export const clearNewsletterDraft = () => setNewsletterDraft('');
